module.exports = __webpack_public_path__ + "media/application/images/ui/icon-menu-hamburger-7af0b78a122f9da9f45d07b894a2d56d.svg";